import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, InputBase } from '@mui/material';

/**
 * @typedef {object} SearchInputProps
 * @property {(searchText: string) => void} [onSearch]
 */

/**
 * @param {SearchInputProps} props
 */
const SearchInput = props => {
  const { onSearch } = props;
  const [value, setValue] = useState('');

  const handleValueChange = event => {
    setValue(event.target.value);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      onSearch(value);
    }
  };

  const handleSearchClick = () => {
    onSearch(value);
  };

  return (
    <InputBase
      placeholder='Search by keyword'
      value={value}
      onChange={handleValueChange}
      onKeyDown={handleKeyDown}
      className='search-input'
      data-testid='search-input'
      endAdornment={
        <InputAdornment position='end'>
          <IconButton onClick={handleSearchClick} data-testid='search-button' size='large'>
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default SearchInput;
